// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1___3edefd2fc0a21c32aea","cls2":"MultiPaperNewsStory-cls2___b47b3fae768014614b6 MultiPaperNewsStory-cls1___3edefd2fc0a21c32aea"};